<template>
  <div class="mapBox" id="mapBox">
    <baidu-map v-bind:style="mapStyle" class="bm-view" mapType="BMAP_SATELLITE_MAP" :center="center"
               :zoom="zoom"
               ak="cFjSMpp64eGNPQZ63hYfoh6POgmZdmr0" :scroll-wheel-zoom="scrollWheelZoom"
               :dragging="dragging"
               @ready="mapHandler" :map-click="false">
      <bm-marker :position="center" :dragging="dragging" animation="BMAP_ANIMATION_BOUNCE">
        <bm-label :content="pointName"
                  :labelStyle="{color: 'red', fontSize: '12px', padding: '5px 10px'}"
                  :offset="{width: 23, height: 2}"/>
      </bm-marker>
      <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                      :offset="{width: 20, height: 20}"
                      :autoLocation="true"></bm-geolocation>
    </baidu-map>
  </div>
</template>

<script>
import {
  BaiduMap,
  BmGeolocation,
  BmControl,
  BmAutoComplete,
  BmLocalSearch,
  BmMarker,
  BmLabel
} from 'vue-baidu-map';

export default {
  components: {
    BaiduMap,
    BmGeolocation,
    BmControl,
    BmAutoComplete,
    BmLocalSearch,
    BmMarker,
    BmLabel
  },
  props: {
    mapHeight: {
      type: Number,
      default: 200
    },
    pointName: {
      type: String,
      default: '定位点'
    },
    lat: {
      type: Number,
      default: 39.915
    },
    lng: {
      type: Number,
      default: 116.404
    },
    dragging:{
      type: Boolean,
      default: true
    },
    scrollWheelZoom:{
      type: Boolean,
      default: true
    }
  },
  watch: {
    lat(newValue) {
      newValue && (this.center.lat = newValue);
    },
    lng(newValue) {
      newValue && (this.center.lng = newValue);
    }
  },
  data() {
    return {
      BMap: {},
      map: {},
      center: {lng: this.lng, lat: this.lat},
      zoom: 15,
      mapStyle: {
        width: '100%',
        height: this.mapHeight + 'px'
      },
      keyword: '',
      iconUrl: 'https://api.map.baidu.com/images/marker_red_sprite.png',
    }
  },
  mounted() {
    document.getElementById('mapBox').removeEventListener('touchmove', (event) => {
      event.preventDefault();
    }, false);
  },
  methods: {
    mapHandler({BMap, map}) {
      this.BMap = BMap; // 核心类
      this.map = map; // 地图实例
      // this.getCurlocation(); // 定位
    },
    getCurlocation() { // 获取浏览器当前定位
      if (!this.BMap) return false;
      let BMap = this.BMap;
      let geolocation = new BMap.Geolocation();
      let _this = this;
      geolocation.getCurrentPosition(r => {
        _this.center = r.point;
      });
    },
    /***
     * 确认
     */
    confirm() {
    },
    /***
     * 取消
     */
    cancel() {
    }
  }
}
</script>

<style lang="stylus">
.mapBox
  height 200px
  width 100%
  display flex
  flex-direction column
  overflow hidden

  .bm-view
    flex 1
    height 100%
    width 100%

    .anchorBL
      display none

    .anchorTL
      width 100%
      padding 9px

      .serachinput
        width 96%
        display block
        padding 9px
        box-sizing border-box
        border 1px solid #dddee1
        line-height 20px
        font-size 14px
        height 38px
        color #333
        position relative
        border-radius 4px
        box-shadow #666 0px 0px 10px

  .footer
    position fixed
    bottom 0
    padding 10px 0
    z-index 999
    width 100%
    background #f1f1f1
    box-shadow #666 0px 0px 10px

    .submit
      text-align center

      button
        width 30%
        margin 0 5%

  .pointImg
    position fixed
    top 50%
    left 50%
    margin-top -30px
    margin-left -16px
    z-index 9999

span
  overflow inherit
</style>
